import React, { useState } from 'react';
import { FileDownIcon, MenuIcon, ClipboardIcon, BarChart2Icon, LayersIcon, LightbulbIcon, BoxIcon, Loader2Icon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { MobileNav } from './MobileNav';
import { exportReportToPdf } from '../utils/exportPdf';
interface HeaderProps {
  timeRange: string;
  setTimeRange: (range: string) => void;
}
export const Header: React.FC<HeaderProps> = () => {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [activeItem, setActiveItem] = useState('overview');
  const [isExporting, setIsExporting] = useState(false);
  const navItems = [{
    id: 'overview',
    label: 'Overview',
    icon: ClipboardIcon,
    section: 'overview',
    href: '#overview'
  }, {
    id: 'performance',
    label: 'Performance',
    icon: BarChart2Icon,
    section: 'performance',
    href: '#performance'
  }, {
    id: 'analysis',
    label: 'Analysis',
    icon: LayersIcon,
    section: 'analysis',
    href: '#analysis'
  }, {
    id: 'statistics',
    label: 'Statistics',
    icon: BoxIcon,
    section: 'statistics',
    href: '#statistics'
  }, {
    id: 'recommendations',
    label: 'Next Steps',
    icon: LightbulbIcon,
    section: 'recommendations',
    href: '#recommendations'
  }];
  const handleExport = async () => {
    if (isExporting) return;
    setIsExporting(true);
    try {
      await exportReportToPdf();
    } catch (err) {
      console.error('Failed to export report', err);
    } finally {
      setIsExporting(false);
    }
  };
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 80; // Adjust this value based on your header height
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setActiveItem(sectionId);
  };
  return <header className="bg-white border-b border-[#E5E5E5] sticky top-0 z-50" data-id="element-209">
      <div className="w-full max-w-[1440px] mx-auto px-6 lg:px-8" data-id="element-210">
        <div className="flex items-center justify-between h-16 relative" data-id="element-211">
          <div className="flex items-center h-full" data-id="element-212">
            <img src="https://cdn.magicpatterns.com/uploads/cw5sXFMyv1tTcWdEavkcR7/8hjmcte754uauw07ypikjkjtx0m5ib450914_(1).svg" alt="Lenovo Logo" className="h-9 w-auto object-contain" data-id="element-213" />
          </div>
          <nav className="hidden md:flex items-center space-x-1 pl-4" data-id="element-214">
            {navItems.map(item => {
            const Icon = item.icon;
            return <a key={item.id} href={item.href} onClick={e => {
              e.preventDefault();
              scrollToSection(item.section);
            }} className={`flex items-center px-3 py-1.5 rounded-sm text-sm transition-colors ${activeItem === item.section ? 'bg-[#C00000]/5 text-[#C00000]' : 'text-[#737373] hover:bg-gray-50'}`} data-id="element-215">
                  <Icon className="h-4 w-4 mr-2" data-id="element-216" />
                  {item.label}
                </a>;
          })}
          </nav>
          <div className="flex items-center space-x-2" data-id="element-217">
            <button onClick={handleExport} disabled={isExporting} className="hidden md:flex items-center space-x-2 bg-white border border-[#101010] text-[#101010] px-4 py-2 rounded-sm font-medium hover:bg-[#101010]/5 transition-colors disabled:opacity-60 disabled:cursor-not-allowed" data-id="element-218">
              {isExporting ? <Loader2Icon className="h-4 w-4 animate-spin" data-id="element-219" /> : <FileDownIcon className="h-4 w-4" data-id="element-220" />}
              <span data-id="element-221">{isExporting ? 'Preparing…' : 'Export'}</span>
            </button>
            <a href="#" className="hidden md:block bg-[#0D5C91] text-white px-4 py-2 rounded-sm font-medium hover:bg-[#0D5C91]/90 transition-colors whitespace-nowrap" data-id="element-222">
              Create new
            </a>
            <button onClick={() => setIsMobileNavOpen(true)} className="md:hidden p-2 hover:bg-gray-50 rounded-none" data-id="element-223">
              <MenuIcon className="h-5 w-5 text-gray-600" data-id="element-224" />
            </button>
          </div>
        </div>
      </div>
      <MobileNav isOpen={isMobileNavOpen} onClose={() => setIsMobileNavOpen(false)} navItems={navItems} activeItem={activeItem} onExport={handleExport} isExporting={isExporting} setActiveItem={id => {
      setActiveItem(id);
      scrollToSection(id);
    }} data-id="element-225" />
    </header>;
};